function demandPriceInfoEvent(){
	$("#ctnContactsUsForPrice").html('<div class="ctnInfoContactPrice form-fields-inline">'+
		'<button type="button" class="btnExit" onClick="exitContactUsForPrice(this);">x</button>'+
		'<div><span class="spLabel">Call us at:</span><a href="tel:310-533-5150">(310) 533-5150</a></div>'+
		'<div><span class="spLabel">email us at:</span><a href = "mailto: support@eio.com">support@eio.com</a></div>'+
		'<div class="lineSplittingForm">Or Contact us Here With This Form</div>'+
		'<form onsubmit="triggerFormContactUsForPrice(this);return false;">'+
			'<div><label>* email:</label><input type="email" name="email"></div>'+
			'<div><label>* Phone:</label><input type="tel" name="phone"/></div>'+
			'<div class="textFieldCtn"><div><label>Description</label></div><textarea name="descrip"/></textarea></div>'+
			'<div class="lineSbtnContactForPrice"><input class="product-form--atc-button" type="submit" value="Submit"/></div>'+
		'</form>'+
	'</div>')
}

function exitContactUsForPrice(){
	btnContactUsForPrice();
}

function btnContactUsForPrice(){
	$('#ctnContactsUsForPrice').html('<button type="button" class="product-form--atc-button" onClick="demandPriceInfoEvent()">Contact us for price</button>');
}

function triggerFormContactUsForPrice(e){
	var l = {},
		token = "3dc11e94a05d69227f11b3a704328ece0b958c30d1c992b01880ff3ef282a2b6",
		url = "https://api.ehub.work",
		changed = false,
		errors = [];

	$(".errorContactUs").remove();

	$($(e).serializeArray()).each(function(index, o) {
		if(["email", "phone", "descrip"].indexOf(o.name) !== -1)
			if(["email", "phone"].indexOf(o.name) !== -1 && o.value.length > 0 || ["email", "phone"].indexOf(o.name) === -1)
				l[o.name] = o.value;
			else	errors.push("Please fill the field: "+o.name);
		else	changed = true;
	})

	l.id_item = parseInt($("#ctnContactsUsForPrice").attr("data-id"));
	console.info('l', l);

	if(errors.length > 0){
		$('#ctnContactsUsForPrice form').prepend('<div class="errorContactUs">' + errors.map(t => {
			return '<div>' + t + '</div>';
		}).join("") + '</div>');
	} else if(l.id_item && !changed && errors.length === 0){
		req(Object.assign({
			"api": "shopify",
			"trigger": "contactForPrice",
			"shop": 205618
		}, l), function(r){
			console.log("Result: ", r);

			if(r.success){
				$('#ctnContactsUsForPrice').html('<div class="successContactUs msgEndReq">Thank You For Your Request.</div>');
			}else
				$('#ctnContactsUsForPrice').html('<div class="errorContactUs msgEndReq">Something went wrong, please try again later or call/email us.</div>');
		}, function(error){
			$(".btnSubmitEditAccount").removeClass("loading").attr("disabled", false)
			console.warn("error", error);
		});
	}
	else	alert("Something went wrong, please call us.");
}

function req(args, callback, failCallback){
	let url = "https://api.ehub.work/task_multi";
	/* if(window.grecaptcha){
		window.grecaptcha.ready(function() {
			let actionName = "recapForceName" in args? args.recapForceName : `${args.api}/${args.trigger}`;
			
			window.grecaptcha.execute("6LdMEKoaAAAAADQDFdOk3F3HC8F9ZjT7eXe6iGiq", {action: actionName}).then(function(token) {
				
				args.token = token;

				$.post(url, Object.assign({
					"token": token,
				}, args)).done(callback).fail(failCallback? failCallback : function(jqXHR, textStatus, errorThrown) {
					alert( "Error:" + textStatus );
					console.warn( textStatus );
				})
			});
		});
	}else{
		if(failCallback)	failCallback("Tken not found");
	} */
	if(grecaptcha){
		grecaptcha.enterprise.ready(function() {
			let actionName = "recapForceName" in args? args.recapForceName : `${args.api}/${args.trigger}`;
			
			grecaptcha.enterprise.execute("6Ld5cM4dAAAAAIR103Fx78hXh9Omssru3RTzABs0", {action: `eio_${actionName}`}).then(function(token) {
				
				args.token = token;

				$.post(url, Object.assign({
					"token": token,
				}, args)).done(callback).fail(failCallback? failCallback : function(jqXHR, textStatus, errorThrown) {
					alert( "Error:" + textStatus );
					console.warn( textStatus );
				})
			});
		});
	}else{
		if(failCallback)	failCallback("Token not found");
	}
}

(function($){
	var jQuery = $

	$(function() {

		(function(){			
			$('.cart--section form').submit(function(e){
				if($('#checkboxConditionCart').is(':checked')){
					return e;
				}else{
					alert('Please accepte our terms and conditions first.');
					e.preventDefault();
				}
			})
		})();

		(function(){
			$(".ctnDescription .product-specifications").each(function(index, node){
				let newctnVal = '<div class="attribute-group">' + 
								$(node).find(".attribute-group-name").get(0).outerHTML;
				$( node ).find(".attribute").each(function(index2, node2){
					newctnVal += '<div class="clearfix attribute-row">';
					newctnVal += $(node2).get(0).outerHTML;
					newctnVal += $(node2).next().get(0).outerHTML;
					newctnVal += '</div>';
				})
				newctnVal += '</div>';

				$(node).html(newctnVal)
			})

			/* $(".navmenu-item").on("click", function(){
				return false;
			})*/


			var dataTouchAdded = false;
			/* $(window).on("mousedown touchstart", function(e){
				console.log("Cliqued");
				
				if(!dataTouchAdded){
					$(".site-navigation .navmenu-depth-1").attr("data-isUsingTouch", true)
					dataMouseAdded = false;
				}
				return e;
			}) */

			var dataMouseAdded = false;
			$(window).on("mousemove", function(){
				if(!dataMouseAdded){
					$(".site-navigation .navmenu-depth-1").attr("data-isUsingTouch", false)
					dataTouchAdded = false;
				}
			})
			
			/* $(".site-header").css("marginTop", $("#shopify-section-static-announcement").height() + "px")
			$(window).on("resize", function(){
				$(".site-header").css("marginTop", $("#shopify-section-static-announcement").height() + "px")
			}) */
		})();

		/* (function(){
			console.log($(".product-ratings").find(".spr-icon-star").length);
			console.log($(".product-ratings").find(".spr-badge").attr("data-rating"));
			console.log($(".product-ratings").find(".shopify-product-reviews-badge").attr("data-id"));

			var limitLoop = 100,
				loop = 0;

			var interTimer = setInterval(function(){

				let rating = $(".product-ratings").find(".spr-badge").attr("data-rating");
				
				if(loop >= limitLoop || rating){

					if(rating){
						console.log("rating", $(".product-ratings").find(".spr-badge").attr("data-rating"));
						let test = JSON.parse($("#scriptProductSeo").text());
						test.review = {
							"@type":"Review",
							"aggregateRating": {
								"@type": "Rating",
								"ratingValue": rating,
								"bestRating": "5"
							}
						};
						$("#scriptProductSeo").text(JSON.stringify(test));
					}
					
					console.log("Ended after 10");
					
					clearInterval(interTimer);
				}

				loop++;
			}, 30);
		})(); */


		(function(){
			// console.log($().jquery);
			let limit = 100,
				count = 0;
			let intCtn = setInterval(function(){
				// console.log($('#ctnContactsUsForPrice').length);
				if(limit < count)
					clearInterval(intCtn);

				if($('#ctnContactsUsForPrice').length > 0){
					btnContactUsForPrice();
					clearInterval(intCtn);
				}
				count++
			}, 50)
			// alert("ok");
			console.info('$(#ctnContactsUsForPrice)', $('#ctnContactsUsForPrice'));
		})();

	

		/* (function(){
			var sizeForAvg = [];
			$(".imgMicroPL").each((index, node) => {
				sizeForAvg.push($(node).height())
			})

			console.info('sizeForAvg', sizeForAvg);
			
			if(sizeForAvg.length > 0){
				// console.info('$size', sizeForAvg.reduce( (v,v2) => v+v2) / sizeForAvg.length);
				var sizeForAvg = sizeForAvg.reduce( (v,v2) => v+v2) / sizeForAvg.length

				if(sizeForAvg > 0)
					$(".imgMicroPL").each((index, node) => {
						$(node).css({
							height: sizeForAvg + "px",
							width: sizeForAvg + "px"
						})
					})
			}
		})(); */

		/* (function(){
			adjustLoginForm();

			window.addEventListener('hashchange', function() {
				adjustLoginForm();
			}, false);
		})();

		function adjustLoginForm(){
			if(location.hash.indexOf("customer_recovery") === -1){
				if($("#customer_login").css("display") == "none"){
		
					$("#customer_login").show()
					$("#customer_recovery").hide()
				}
			}else{
				if($("#customer_recovery").css("display") == "none"){
					
					$("#customer_login").hide()
					$("#customer_recovery").show()
				}
			}
		} */

		(function(){
			$(".btnEditAccount").click(e => {
				$("#formEditUserData").addClass("editMode")
				$("#checkboxMarketing").attr("disabled", false)
			})

			$(".btnSubmitCloseEdit").click(e => {
				$("#formEditUserData").removeClass("editMode")
				$("#ctnAjaxSuccess").html("").css("display", "none");
				$("#ctnAjaxError").html("").css("display", "none");
				$("#checkboxMarketing").attr("disabled", true)
			})

			$('#formEditUserData').submit(function(e){
				e.preventDefault();

				try {
					var l = {},
						propertyWanted = ["id_customer", "new_email", "current_email", "phone", "accepts_marketing"],
						propertyRequired = ["id_customer", "new_email", "current_email"],
						errors = [];

					$("#ctnAjaxSuccess").html("").css("display", "none");
					$("#ctnAjaxError").html("").css("display", "none");

					$($(this).serializeArray()).each(function(index, o) {
						if(propertyWanted.indexOf(o.name) !== -1)
							if(propertyRequired.indexOf(o.name) !== -1 && o.value != null || propertyRequired.indexOf(o.name) === -1)
								l[o.name] = o.value;
							else	errors.push("Please fill the field: "+o.name);
					})

					// console.info('ll', l);
					// return;
					
					if(errors.length > 0){
						$('#ctnAjaxError').html(errors.map(t => {
							return '<div>' + t + '</div>';
						}).join("")).css("display", "block");
					} else if(l.id_customer && errors.length === 0){

						$(".btnSubmitEditAccount").addClass("loading").attr("disabled", true)

						req(Object.assign({
							"api": "shopify",
							"trigger": "updateAccount",
							"shop": 205618
						}, l), function(r){
							console.log("Result: ", r);
							$(".btnSubmitEditAccount").removeClass("loading").attr("disabled", false)
							if(r.success){
								$('#ctnAjaxSuccess').html('Account updated').css("display", "block");
							}else
								$('#ctnAjaxError').html(r.errors.map(err => {
									return '<div>'+err+'</div>'
								}).join('')).css("display", "block"); // 'Something went wrong, please try again later or call/email us.'
						}, function(error){
							$(".btnSubmitEditAccount").removeClass("loading").attr("disabled", false)
							alert(error);
						});
					}
				} catch (error) {
					console.warn(error);
				}
			})
		})();

	});

})(window.jQuery);

